// extracted by mini-css-extract-plugin
module.exports = {"appRed":"#b22028"};